import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/conversacionbanca.png";
import Card from "../../../components/Card";
import Modulo12U1Act3 from "../../../DnD/modulo12U1Act3";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad2.mp3";

const items = [
  <div className="selectable btn btn-red shadow mx-3 my-1">discriminar</div>,
  <div className="selectable btn btn-red shadow mx-3 my-1">migrar</div>,
  <div className="selectable btn btn-red shadow mx-3 my-1">incluir</div>,
];

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "migró" },
    ans2: { value: "", valid: "", correctValue: "discriminada" },
    ans3: { value: "", valid: "", correctValue: "incluían" },
  });
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[2];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[3].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[3].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[1].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <div>
        <h2 className="mb-5">{infoAct.name}</h2>
        <AudioPlayer track={Audio} />
      </div>
      <ul className="mb-5">
        <li>Arrastra cada palabra a la definición que le corresponde.</li>
      </ul>

      <Modulo12U1Act3 items={items} />
      <ul className="mt-5">
        <li>
          Ahora completa el texto escribiendo las palabras adecuadas. Escógelas
          del recuadro. Tu profesor, profesora o acompañante te ayudará.
        </li>
      </ul>

      <Card>
        <div className="d-flex justify-content-around">
          <div>incluían</div>
          <div>discriminada</div>
          <div>migró</div>
        </div>
      </Card>

      <img src={Imagen1} alt="Ministra" className="img-fluid" />
      <div className="row my-4">
        <div className="col-md-10 col-12">
          <Card>
            <p>
              Olga Quispe{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              de su pueblo en Huancavelica para buscar trabajo en la capital. Ya
              en Lima, se sintió muchas veces
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />{" "}
              por venir de la sierra. Pero también encontró amigos que la{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />{" "}
              en sus actividades. Olga disfruta mucho contándoles sobre su
              pueblo. Están planeando ir todos juntos pronto.
            </p>
          </Card>

          <button
            className={`btn float-end btn-${modulo12.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Explique que estas actividades tienen como objetivo conocer palabras
            nuevas que les serán muy útiles, sobre todo en la escuela. En este
            caso, trabajarán con las palabras “discriminar”, “migrar”, “incluir”
            y “excluir” o sus variantes.
          </li>
          <li>
            Lea la indicación: Arrastra cada palabra a la definición que le
            corresponde. Explique que cada una de las palabras (“discriminar”,
            “migrar” e “incluir”), debe colocarse con alguno de los significados
            que aparecen abajo. Dé tiempo para que realicen el ejercicio en
            silencio. Una vez que todos hayan terminado, revise el ejercicio.
          </li>
          <li>
            Confirme que niños y niñas han comprendido las palabras pidiéndoles
            que elaboren algunas oraciones con ellas. Explique que pueden usarse
            variaciones de dichas palabras, como “discriminación” o “incluimos”.
            Dé usted algunos ejemplos previos. Por ejemplo:
            <ul>
              <li>
                <i>
                  "Los muchachos discriminaron a María. No la dejaron jugar al
                  fútbol por ser mujer. Juan dejó su casa en el campo y migró a
                  la ciudad. Las alumnas incluyeron a la nueva estudiante en su
                  banda musical."
                </i>
              </li>
            </ul>
          </li>
          <li>
            Lea la indicación: Ahora completa el texto escribiendo las palabras
            adecuadas. Escógelas del recuadro. Tu profesor, profesora o familiar
            te ayudará.
          </li>
          <li>
            Pida a un niño o niña que lea las palabras del recuadro: incluían –
            discriminada – migró.
          </li>
          <li>
            Lean el texto y deténgase en cada espacio en blanco para preguntar a
            niños y niñas con qué palabra lo llenarían. Es importante que,
            conforme vayan leyendo, les recuerde los significados de las
            palabras aprendidos en la actividad anterior. Cuando terminen de
            colocar las palabras en el texto, léalo una vez más.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
